import '../../App.scss'
import Fade from 'react-reveal/Fade';
import ReactHtmlParser from "react-html-parser";
import {useHistory} from 'react-router'

export default function Artifact(info) {
    const history = useHistory()
    const {content, selfLink, id, title} = info.info
    const blogId = info.info.blog.id
    let div = document.createElement('div');
    div.innerHTML = content;
    let firstImage = div.getElementsByTagName('img')[0]
    let imgSrc = firstImage ? firstImage.src : "";

    return (
   <div onClick={()=>history.push(`/museum/post/${blogId}/${id}/${title}`)}className="ArtifactPreview">
       <h2>{title}</h2>
       <img src={imgSrc} alt="image unavailable" />

   </div>
    );
}
